import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharedService } from './sharedService';
import { PortalDashboardGroup } from '../entities/portalDashboardGroup';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

/**
 * Admin CRUD for portal dashboard groups (ADMIN-only server side). Errors are
 * NOT swallowed here: the delete-refused and key-collision messages are the
 * point, so the component subscribes to the error channel and shows them.
 */
@Injectable()
export class PortalDashboardGroupService {

  constructor(private http: HttpClient, private sharedService: SharedService) {}

  list(): Observable<PortalDashboardGroup[]> {
    return this.http.get<PortalDashboardGroup[]>(this.sharedService.apiUrl('api/portal-dashboard-group'));
  }

  get(id: string): Observable<PortalDashboardGroup> {
    return this.http.get<PortalDashboardGroup>(this.sharedService.apiUrl('api/portal-dashboard-group/' + id));
  }

  add(group: PortalDashboardGroup): Observable<PortalDashboardGroup> {
    return this.http.post<PortalDashboardGroup>(
      this.sharedService.apiUrl('api/portal-dashboard-group/add'), group, httpOptions);
  }

  delete(id: any): Observable<any> {
    return this.http.post<any>(
      this.sharedService.apiUrl('api/portal-dashboard-group/delete'), { id }, httpOptions);
  }
}
